import React from "react";
import KickImage from 'Reuseables/KickImage';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Row,
  Col,
  Button
} from "reactstrap";
import ReactLoading from "react-loading";
import Calendar from "react-calendar";
import moment from "moment";
import styled, { consolidateStreamedStyles } from "styled-components";
import _ from "lodash";

import { getCacheImage } from "../../config";
import CloseIcon from "../../images/close30.png";

import {
  ADMINISTRATOR,
  APPROVED,
  SUSPEND,
  REJECTED,
  UNDER_REVIEW,
  WAIT_CONFIRM,
  WAIT_CONSIGN,
  CANCELLED,
  DRAFT,
  MORE_INFO,
  SEMPURNA,
  CACAT,
  NO_BOX,
  BARU,
  BEKAS,
  LISTING,
  emptyImage
} from "../../utils";

import {
  normalizeBrand,
  getCloudImageUrl,
  handleProductConditions
} from "../../utils/Helpers";

const convertToDate = str =>
  typeof str === "string"
    ? new Date(moment(str).toISOString())
    : moment.isMoment(str)
      ? new Date(str.toISOString())
      : new Date();

const ExpiryDate = ({
  roles,
  expiry,
  day_lefts
}) => {
  if (roles.includes('trusted_seller')) {
    return (
      <div className="wrapper no-expiry-wrapper">
        <span>No Expiry</span>
      </div>
    )
  }

  if (expiry) {
    if (status === "approved" && day_lefts <= 0) {
      // setIsTextToggleAble(true)
      return (
        <div className="wrapper expired-wrapper">
          <span>Expired</span>
        </div>
      )
    } else {
      // setIsTextToggleAble(true)
      return (
        <div className="wrapper expired-at-wrapper">
          <p>
            <span className="text">Expired at </span> <span className="date">{moment(expiry).format('DD/MM/YYYY')}</span>
          </p>
        </div>
      )
    }
  }

  return <span className="selling-date expired non-underline">-</span>
}

const ModalExpiryDate = props => {
  const {
    expiry,
    roles,
    status,
    day_lefts
  } = props
  const {
    size,
    display_name,
    product_variant_id,
    product_variant,
    slug,
    SKU,
    category
  } = props.data || {}

  const isFullFilled = () => {
    let result = false

    if (props.value) {
      result = true
    }

    return result
  }

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.onToggle}
      className="kick-modal detail-selling"
      id={props.id}
    >
      <Container>
        <div className="close-icon-wrapper">
          <KickImage
            onClick={props.onToggle}
            src={CloseIcon}
            alt="close-icon"
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="product-info">
          <div className="display-name">
            <p
              onClick={() =>
                props.history.push(
                  `/${categoryUrl}/${product_variant_id}/${slug}`
                )
              }>
              {display_name}
            </p>
            <div className="size-wrapper">
              <p>{size}</p>
            </div>
          </div>
          <p>{SKU}</p>
        </div>
        <div className="image-wrapper">
          <KickImage
            src={
              !props.data.image
                ? getCloudImageUrl(props.data.image.URL, 400)
                : emptyImage(props.data.category)
            }
            alt=""
            // onError={e => onErrorImg(e)}
          />
        </div>
        <div className="details-info-wrapper">
          <div className="top-info">
            <div className="consignment-wrapper">
              <p>Consignment ID</p>
              <p>
                {
                  props.data.consignment_id !== null
                    ? props.data.consignment_id
                    : "-"
                }
              </p>
            </div>
            <div className="approved-at">
              <p>Approved At</p>
              <p>
                {
                  props.data.approved_at !== null
                    ? moment(props.data.approved_at).format("DD-MMM-YYYY")
                    : "-"
                }
              </p>
            </div>
          </div>
          <div className="bottom-info">
            <p>Product Conditions</p>
            <p>
              {product_variant?.vintage
                ? 'Vintage'
                : handleProductConditions(props.data, props.data.category)}
            </p>
          </div>
        </div>
        <div className="set-expiry-date-wrapper">
          <p>Set Expiry Date</p>
          <ExpiryDate
            roles={roles}
            expiry={expiry}
            day_lefts={day_lefts}
          />
        </div>
        <div className="calender-wrapper">
          <Calendar
            minDate={convertToDate(
              moment()
                .add(7, "days")
                .format("YYYY-MM-DD")
            )}
            value={props.value ? convertToDate(props.value) : null}
            onChange={props.onChangeDate}
            locale="en-us"
          />
        </div>
        <div className="error-wrapper">
          <p>{props.error}</p>
        </div>
        <div className="button-wrapper">
          <Button
            onClick={() => props.submitExpiry(props.data.id)}
            disabled={props.isProcessSubmit}
            className={`${isFullFilled() ? "" : "disabled"}`}
          >
            {props.isProcessSubmit ? (
              <ReactLoading type={"bars"} height={20} width={20} />
            ) : (
              "Save Changes"
            )}
          </Button>
        </div>
      </Container>
    </Modal>
  );
};

const ButtonWrapper = styled.div`
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: ${props =>
    props.hide_box_info ? "1fr 1fr 1fr" : props.isVintage ? "1fr 1fr" : "1fr 1fr 1fr 1fr"};
  grid-column-gap: 0.5rem;
`;

const infoString = data => {
  switch (data) {
    case SEMPURNA[0]:
      return SEMPURNA[2];
    case CACAT[0]:
      return CACAT[1];
    case NO_BOX[0]:
      return NO_BOX[1];
    case BARU[0]:
      return BARU[2];
    case BEKAS[0]:
      return BEKAS[2];
    case APPROVED:
      return LISTING[0];
    case SUSPEND:
      return LISTING[1];
    case DRAFT[0]:
      return DRAFT[1];
    case MORE_INFO[0]:
      return MORE_INFO[1];
    case CANCELLED[0]:
      return CANCELLED[1];
    case WAIT_CONFIRM[0]:
      return WAIT_CONFIRM[1];
    case WAIT_CONSIGN[0]:
      return WAIT_CONSIGN[1];
    case UNDER_REVIEW[0]:
      return UNDER_REVIEW[1];
    case REJECTED[0]:
      return REJECTED[1];
    case false:
      return "Complete Accessories";
    case true:
      return "Missing Accessories";
    default:
      return ADMINISTRATOR;
  }
};

export default ModalExpiryDate;
